import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton } from './BuyButton';
export function Hero() {
  return <section className="pt-12 pb-16 px-4 bg-[#f8f9fa] relative overflow-hidden" data-id="element-51">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-52">
        <motion.h1 initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-3xl md:text-5xl text-[#1a3d1f] mb-8 uppercase leading-[0.92] tracking-tight max-w-4xl mx-auto" data-id="element-53">
          Dejá de dudar en cada jugada. Y aprendé exactamente cuándo subir y
          cuándo quedarte.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3
      }} className="mb-8 relative" data-id="element-54">
          <img src="https://cdn.magicpatterns.com/uploads/3vzovBPsrEQ7vsdNsUA9mv/ChatGPT_Image_Jun_8__2026__02_04_20_AM-removebg-preview.png" alt="El Manual Del Lateral Moderno" className="w-full max-w-xl mx-auto cursor-pointer" onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-55" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-56">
          Un sistema práctico para entender la posición, corregir errores y
          rendir mejor cada vez que entrás a la cancha.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7
      }} className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-57">
          {['📄 100% PDF', '⚡ Acceso Inmediato', '📚 5 Capítulos + 5 Bonos', '⭐️ 4.9/5.0'].map((badge, i) => <span key={i} className="bg-white border border-[#1a3d1f]/10 text-[#1a3d1f] font-semibold py-2 px-4 rounded-full shadow-sm text-sm md:text-base" data-id="element-58">
              {badge}
            </span>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.9
      }} data-id="element-59">
          <BuyButton data-id="element-60" />
        </motion.div>
      </div>
    </section>;
}